/**
 * Import main libs
 */
import angular from 'angular';
import 'normalize.css';
import 'angular-ui-router';
import 'angular-animate';
import 'angular-touch';
import 'angular-carousel';
import 'angular-modal-service';

import 'angular-carousel/dist/angular-carousel.min.css'
import './less/screenSaver.less';
import Config from './config';

import GetConfigurationFileService from './services/getConfiguration';
import screenSaver from './services/screenSaver';

import init from './init';

import appNav from './directives/app-nav';
import hotSpot from './directives/hot-spot';
import pfContainer from './directives/pf-container';
import sidebar from './directives/sidebar';
import console from './directives/console';


const MODULE_NAME = 'app';


let app = angular.module(MODULE_NAME, ['ui.router', 'ngAnimate', 'angular-carousel', 'angularModalService']);
app.directive('appNav', [appNav]);
app.directive('console', [console]);
app.directive('hotSpot', [hotSpot]);
app.directive('pfContainer', ['$timeout', pfContainer]);
app.directive('sidebar', ['$rootScope', 'ModalService', sidebar]);
app.factory('Config', ['$rootScope', '$http', '$q', GetConfigurationFileService]);
app.factory('screenSaver', ['$rootScope', '$http', '$q', '$interval', '$document', screenSaver]);
app.run(init);
app.config(Config);


export default MODULE_NAME;



// WEBPACK FOOTER //
// ./src/app/app.js